import React, { useEffect } from "react";
import CartItems from '../Components/CartItems/CartItems'


const Cart = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top when component mounts
      }); 

    return (
        <div>
            <CartItems/>
        </div>
    )
}

export default Cart